import requests from "./httpService";

const StoreServices = {
  // Store Management
  createStore(franchiseId, storeData) {
    return requests.post(`/api/franchises/${franchiseId}/stores`, storeData);
  },

  getFranchiseStores(franchiseId) {
    return requests.get(`/api/franchises/${franchiseId}/stores`);
  },

  getAllStores() {
    return requests.get("/api/stores/all");
  },

  getStoreByUserId(userId) {
    return requests.get(`/api/stores/user/${userId}`);
  },

  updateStore(storeId, storeData) {
    return requests.put(`/api/stores/${storeId}`, storeData);
  },

  deleteStore(storeId) {
    return requests.delete(`/api/stores/${storeId}`);
  },

  // Store Employees
  createEmployee(storeId, employeeData) {
    return requests.post(`/api/stores/${storeId}/employees`, employeeData);
  },

  getStoreEmployees(storeId) {
    return requests.get(`/api/stores/${storeId}/employees`);
  },

  // Store Services
  createService(storeId, serviceData) {
    return requests.post(`/api/stores/${storeId}/services`, serviceData);
  },

  getStoreServices(storeId) {
    return requests.get(`/api/stores/${storeId}/services`);
  },

  // Store Billings
  createBill(storeId, billingData) {
    return requests.post(`/api/stores/${storeId}/billings`, billingData);
  },

  getStoreBills(storeId) {
    return requests.get(`/api/stores/${storeId}/billings`);
  },

  // Store Reports
  getDailySalesReport(storeId, date) {
    return requests.get(
      `/api/stores/${storeId}/reports/daily-sales?date=${date}`
    );
  },

  getMonthlySalesReport(storeId, month, year) {
    return requests.get(
      `/api/stores/${storeId}/reports/monthly-sales?month=${month}&year=${year}`
    );
  },

  getEmployeePerformance(storeId) {
    return requests.get(`/api/stores/${storeId}/reports/employee-performance`);
  },
};

export default StoreServices;
